export default __webpack_public_path__ + "static/media/m6.ef8425fb.webp";